<template>
  <div class="flex flex-col flex-nowrap items-center gap-6 md:flex-row md:gap-32">
    <div class="w-full md:w-2/6">
      <TypographyTitle size="xl" as="h1" :html="heading" />
    </div>

    <div class="w-full md:w-4/6">
      <div class="hero-teaser text-brand-600 mb-8 text-[13px]" v-html="teaser" />

      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface ArticleHubHero {
  heading?: string;
  teaser?: string;
}
const props = defineProps<ArticleHubHero>();
</script>
